import React from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import CustomDatePicker from "../../components/CustomDatePicker";
import { ICONS } from "./constants";

export default function TeacherMinuteEditModal({
  editingMinute,
  handleMinuteEditMouseDown,
  handleMinuteSubmit,
  isMinutesModalOpen,
  minuteEditModalPos,
  minuteFormData,
  onClose,
  setMinuteFormData,
  theme,
}) {
  if (!isMinutesModalOpen) return null;

  return createPortal(
    <div className="fixed inset-0 bg-transparent flex items-center justify-center z-[9995] p-4 pointer-events-none" onClick={onClose}>
      <div
        className="bg-white rounded-[2.5rem] w-full max-w-lg shadow-2xl relative border border-white/50 flex flex-col pointer-events-auto"
        onClick={(e) => e.stopPropagation()}
        style={{ transform: `translate(${minuteEditModalPos.x}px, ${minuteEditModalPos.y}px)` }}
      >
        <div
          className="flex justify-between items-center p-6 pb-2 cursor-move"
          onMouseDown={handleMinuteEditMouseDown}
        >
          <h3 className="text-2xl font-black text-[#2C3E30] flex items-center gap-3 font-do-hyeon">
            <img src={ICONS.notebook} width={32} alt="icon" /> {editingMinute ? "회의록 수정" : "회의록 작성"}
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600"><X size={24} /></button>
        </div>
        <div className="p-8 pt-2">
          <form onSubmit={handleMinuteSubmit} className="space-y-4">
            <div className="flex gap-3">
              <div className="w-1/3">
                <label className="text-xs font-bold text-gray-500 ml-1 mb-1 block">날짜</label>
                <CustomDatePicker
                  theme={theme}
                  value={minuteFormData.date}
                  onChange={(date) => setMinuteFormData({ ...minuteFormData, date })}
                  className="w-full"
                />
              </div>
              <div className="flex-1"><label className="text-xs font-bold text-gray-500 ml-1 mb-1 block">제목</label><input required className="w-full bg-[#F9F9F8] border border-gray-200 p-3.5 rounded-2xl font-bold focus:outline-none focus:border-[#354F38] transition" placeholder="예: 5월 교사 월례회" value={minuteFormData.title} onChange={(e) => setMinuteFormData({ ...minuteFormData, title: e.target.value })} /></div>
            </div>
            <div><label className="text-xs font-bold text-gray-500 ml-1 mb-1 block">참석자 (쉼표로 구분)</label><input className="w-full bg-[#F9F9F8] border border-gray-200 p-3.5 rounded-2xl font-bold focus:outline-none focus:border-[#354F38] transition" placeholder="김철수, 이영희, 박지성" value={minuteFormData.attendees} onChange={(e) => setMinuteFormData({ ...minuteFormData, attendees: e.target.value })} /></div>
            <div><label className="text-xs font-bold text-gray-500 ml-1 mb-1 block">내용</label><textarea required className="w-full bg-[#F9F9F8] border border-gray-200 p-4 rounded-2xl font-medium focus:outline-none focus:border-[#354F38] transition resize-none h-48 leading-relaxed" placeholder="회의 내용을 자유롭게 작성하세요." value={minuteFormData.content} onChange={(e) => setMinuteFormData({ ...minuteFormData, content: e.target.value })} /></div>
            <button className={`w-full ${theme.bg} text-white py-4 rounded-2xl font-black text-lg hover:opacity-90 transition shadow-xl ${theme.shadow}/20 mt-2`}>저장하기</button>
          </form>
        </div>
      </div>
    </div>,
    document.body
  );
}
